import { useMemo } from 'react';
import useUAParser from 'hooks/useUAParser';
import { useSelector } from 'react-redux';
import { selectTenant } from 'state/tenant';
import isChromeBrowser from 'utils/isChromeBrowser';
import { includes } from 'ramda';

type WalletButtonHook = () => {
  hasAppleButton: boolean;
  hasGoogleButton: boolean;
  hasWalletButton: boolean;
};

const useWalletButton: WalletButtonHook = () => {
  const {
    enabledFeatures: { wallet },
  } = useSelector(selectTenant);
  const {
    device: { model },
    os: { name: os },
    browser: { name: browserName = '' },
  } = useUAParser();

  const hasAppleButton = useMemo(() => {
    return (
      Boolean(wallet) && includes(os, ['Mac OS', 'iOS']) && model !== 'iPad'
    );
  }, [model, wallet, os]);

  const hasGoogleButton = useMemo(() => {
    return (
      Boolean(wallet) && (isChromeBrowser(browserName) || os === 'Android')
    );
  }, [browserName, os, wallet]);

  const hasWalletButton = hasAppleButton || hasGoogleButton;

  return {
    hasAppleButton,
    hasGoogleButton,
    hasWalletButton,
  };
};

export default useWalletButton;
